import React from 'react';

import { Link } from 'react-router-dom'; 
const DonationList = () => {
    return (
        <div>
          
            {/* SIDEBAR SECTION START */}
            <div className="ul-sidebar">
                {/* header */}
                <div className="ul-sidebar-header">
                    <div className="ul-sidebar-header-logo">
                        <Link to="/">
                            <img src="assets/img/logo.svg" alt="logo" className="logo" />
                        </Link>
                    </div>
                    {/* sidebar closer */}
                    <button className="ul-sidebar-closer"><i className="flaticon-close"></i></button>
                </div>

                {/* sidebar footer */}
                <div className="ul-sidebar-footer">
                    <span className="ul-sidebar-footer-title">Follow us</span>
                    <div className="ul-sidebar-footer-social">
 <Link to="#"><i className="flaticon-facebook"></i></Link>
                        <Link to="#"><i className="flaticon-twitter"></i></Link>
                        <Link to="#"><i className="flaticon-instagram"></i></Link>
                        <Link to="#"><i className="flaticon-youtube"></i></Link>
                    </div>
                </div>
            </div>
            {/* SIDEBAR SECTION END */}

            {/* SEARCH MODAL SECTION START */}
            <div className="ul-search-form-wrapper flex-grow-1 flex-shrink-0">
                <button className="ul-search-closer"><i className="flaticon-close"></i></button>
                <form action="#" className="ul-search-form">
                    <div className="ul-search-form-right">
                        <input type="search" name="search" id="ul-search" placeholder="Search Here" />
                        <button type="submit"><span className="icon"><i className="flaticon-search"></i></span></button>
                    </div>
                </form>
            </div>
            {/* SEARCH MODAL SECTION END */}

            {/* HEADER SECTION START */}
          
            {/* HEADER SECTION END */}

            <main>
                {/* BREADCRUMBS SECTION START */}
                <section className="ul-breadcrumb ul-section-spacing">
                    <div className="ul-container">
                        <h2 className="ul-breadcrumb-title">Donation Listing</h2>
                        <ul className="ul-breadcrumb-nav">
                              <li><Link to="/">Home</Link></li>
                            <li><span className="separator"><i className="flaticon-right"></i></span></li>
                            <li>Donation Listing</li>
                        </ul>
                    </div>
                </section>
                {/* BREADCRUMBS SECTION END */}

                {/* DONATIONS SECTION START */}
                <section className="ul-section-spacing overflow-hidden">
                    {/* DONATIONS Grid */}
                    <div className="ul-container wow animate__fadeInUp">
                        <div className="row ul-bs-row row-cols-xl-4 row-cols-md-3 row-cols-2 row-cols-xxs-1">
                            {/* single item */}
                            {Array.from({ length: 8 }).map((_, index) => (
                                <div className="col" key={index}>
                                    <div className="ul-donation ul-donation--inner">
                                        <div className="ul-donation-img">
                                            <img src={`assets/img/donation-${(index % 4) + 1}.jpg`} alt="donation Image" />
                                            <span className="tag">Foods</span>
                                        </div>
                                        <div className="ul-donation-txt">
                                            <div className="ul-donation-progress">
                                                <div className="donation-progress-container ul-progress-container">
                                                    <div className="donation-progressbar ul-progressbar" data-ul-progress-value="55" style={{width: "95%"}}>
                                                        <div className="donation-progress-label ul-progress-label"></div>
                                                    </div>
                                                </div>
                                                <div className="ul-donation-progress-labels">
                                                    <span className="ul-donation-progress-label">Raised : $25,000</span>
                                                    <span className="ul-donation-progress-label">Goal : $30,000</span>
                                                </div>
                                            </div>
                                             <Link to="/donation-details" className="ul-donation-title">Lifes kills for Children in South African peoples</Link>
                                            <p className="ul-donation-descr">We work together to make a lasting difference, helping people. With kindness and hard work</p>
                                            <Link to="/donation-details" className="ul-donation-btn">Donate now <i className="flaticon-up-right-arrow"></i></Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* pagination */}
                    <div className="ul-pagination">
                        <ul>
                            <li><Link to="#"><i className="flaticon-back"></i></Link></li>
                            <li className="pages">
                                <Link to="#" className="active">1</Link>
                                <Link to="#">2</Link>
                                <Link to="#">3</Link>
                            </li>
                            <li><Link to="#"><i className="flaticon-next"></i></Link></li>
                            </ul>
                    </div>
                </section>
                {/* DONATIONS SECTION END */}
            </main>

            {/* FOOTER SECTION START */}
          
            {/* FOOTER SECTION END */}

            {/* libraries JS */}
            <script src="assets/vendor/bootstrap/bootstrap.bundle.min.js"></script>
            <script src="assets/vendor/splide/splide.min.js"></script>
            <script src="assets/vendor/splide/splide-extension-auto-scroll.min.js"></script>
            <script src="assets/vendor/swiper/swiper-bundle.min.js"></script>
            <script src="assets/vendor/slim-select/slimselect.min.js"></script>
            <script src="assets/vendor/animate-wow/wow.min.js"></script>
            <script src="assets/vendor/splittype/index.min.js"></script>
            <script src="assets/vendor/mixitup/mixitup.min.js"></script>
            <script src="assets/vendor/fslightbox/fslightbox.js"></script>
            <script src="assets/vendor/flatpickr/flatpickr.js"></script>

            {/* custom JS */}
            <script src="assets/js/main.js"></script>
            <script src="assets/js/tab.js"></script>
            {/* <script src="assets/js/countdown.js"></script> */}
            <script src="assets/js/accordion.js"></script>
            <script src="assets/js/progressbar.js"></script>
        </div>
    );
};

export default DonationList;
